import { MachineSystemData, RefreshData } from '@uv/machine'

type AlarmBools = RefreshData['ALARMS'] | MachineSystemData['OVERRIDES']

export const createDisabledOverrides = (
  currentAlarms: AlarmBools
): MachineSystemData['OVERRIDES'] => {
  if (currentAlarms.length === 8) return [false, false, false, false, false, false, false, false]
  return [false, false, false, false, false, false, false, false, false]
}

export const createPressureSlipOverrides = (
  currentAlarms: AlarmBools
): MachineSystemData['OVERRIDES'] => {
  if (currentAlarms.length === 8) return [false, false, false, false, false, true, true, false]
  return [false, false, false, false, false, true, true, false, false]
}
